module.exports = __webpack_public_path__ + "static/img/IMG_20240610_112401.4a5d087a.jpg";